export const Religions = [
  { id: "cathar_milieu", name: "Cathar milieu", color: "#8719E0" },
  { id: "apostolic_milieu", name: "Apostolic milieu", color: "#3ebd93" },
  { id: "other_heterodoxy", name: "other heterodoxy", color: "#F0B429" },
  { id: "undef_heresy", name: "unknown", color: "#E8E6E1" },
];
